export default __webpack_public_path__ + "static/media/edit-icon-24px.ea665c3f.svg";